import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Container = styled('div')`
    display: flex;
    align-items: center;
    margin-bottom: 32px;
    padding: 20px 0 20px 7px;
`
export const Title = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: row;
    gap: 5px;
    color: ${({ theme, color }) => color || theme.colors.greys[0]};
`
export const IconContainer = styled('div', {
    shouldForwardProp: (prop) => prop !== 'iconGap',
})<{ iconGap?: number }>`
    margin-right: ${({ iconGap }) => iconGap ?? 15}px;
    display: flex;
`
